import { AxiosResponse } from 'axios'
import { RequestREAD } from 'services/Instances'

export const PendingCreServices = () => {
  const path = 'CarteiraItem'

  const getPendencia = async (
    params: ISearchPendingParams
  ): Promise<AxiosResponse<ISearchPendingResponse>> =>
    await RequestREAD.get(`${path}/Pendencia`, { params })

  const getIFilterPendingCre = async (
    params: IFilterPendingCre
  ): Promise<AxiosResponse<IPendingCreSearchResponse>> =>
    await RequestREAD.get(`${path}/PesquisaPendencias`, { params })

  const generalSearch = async (
    querySearch: string,
    pageSize: number,
    pageNumber: number
  ): Promise<AxiosResponse<ISearchPendingResponse>> =>
    RequestREAD.get(path + '/PesquisaGeral', {
      params: { pageNumber, pageSize, querySearch }
    })

  return { generalSearch, getIFilterPendingCre, getPendencia }
}

export const PendingCreFilterServices = () => {
  const path = 'Cre'

  const getPesquisaPendencias = async (
    params: ISearchFilterPendingParams
  ): Promise<AxiosResponse<IPendingCreSearchResponse>> =>
    await RequestREAD.get(`${path}/PesquisaPendencias`, { params })

  return { getPesquisaPendencias }
}

export interface ISearchPendingParams {
  NuBacklog?: string
  NuBloqueio?: string
  NuSubcontratacao?: string
  NuDataAnexada?: string
  pageNumber: number
  pageSize: number
  QuerySearch?: string
}

export interface ISearchPendingResponse {
  pageCount: number
  totalItemCount: number
  pageNumber: number
  pageSize: number
  hasPreviousPage: boolean
  hasNextPage: boolean
  isFirstPage: boolean
  isLastPage: boolean
  firstItemOnPage: number
  lastItemOnPage: number
  items: IPendingCre[]
}

export interface IPendingCre {
  movimentacaoId: number
  movDocId: number
  nuAnoMesCompetencia: string
  fornecedorId: number
  nmFornecedor: string
  idCre: number
  contratoId: number
  cdContrato: string
  cdCodigoCre: string
  dtAnexado: string
  dtLiberacao?: string | Date
  flCreBloqueado: boolean
  flSubContrato: boolean
  nmAnalista: string
  vlSla: number
  flSla: boolean
  txStatusColor: string
  txDescDoc?: string
  statusBacklog: boolean
  flEmAnalise: boolean
}

export interface IFilterPendingCre {
  CdContrato?: string
  NmFornecedor?: string
  CompetenciaInicio?: number
  CompetenciaFim?: number
  CdCRE?: string
  NmAnalista?: string
  DtAnaliseInicio?: string
  DtAnaliseFim?: string
  DtAnexoInicio?: string
  DtAnexoFim?: string
  DtPeriodoInicio?: string
  DtPeriodoFim?: string
  FlBacklog?: boolean
  FlCreBloqueado?: boolean
  FlSubContrato?: boolean
  PageNumber?: number
  PageSize?: number
}

export interface IPendingCreSearch {
  txDescDoc?: string
  movimentacaoId?: number
  movDocId?: number
  nuAnoMesCompetencia?: string
  fornecedorId?: number
  nmFornecedor?: string
  idCre?: number
  contratoId?: number
  cdContrato?: string
  cdCodigoCre?: string
  dtAnexado?: string
  flCreBloqueado?: boolean
  flSubContrato?: boolean
  nmAnalista?: string
  dtAnalise?: string
  dtLiberacao?: string
  dtUltimaAnalise?: string
  vlSla?: number
  flSla?: boolean
  txStatusColor?: string
  statusBacklog?: boolean
  flEmAnalise?: boolean
}

export interface IPendingCreSearchResponse {
  pageCount?: number
  totalItemCount?: number
  pageNumber?: number
  pageSize?: number
  hasPreviousPage?: boolean
  hasNextPage?: boolean
  isFirstPage?: boolean
  isLastPage?: boolean
  firstItemOnPage?: number
  lastItemOnPage?: number
  items?: IPendingCreSearch[]
}

export interface ISearchFilterPendingParams {
  CdContrato?: string
  NmFornecedor?: string
  CompetenciaInicio?: number
  CompetenciaFim?: number
  CdCRE?: string
  NmAnalista?: string
  DtAnaliseInicio?: string
  DtAnaliseFim?: string
  DtAnexoInicio?: string
  DtAnexoFim?: string
  DtPeriodoInicio?: string
  DtPeriodoFim?: string
  FlBacklog?: boolean
  FlCreBloqueado?: boolean
  FlSubContrato?: boolean
  FlTodos?: boolean
  PageNumber?: number
  PageSize?: number
}
